import client from "./client";

export const fetchWholesaleIps = (user, deviceid, page, pagesize) => {
  return client.get(`/user/${user}/voip/${deviceid}/wholesale/trunk`);
};
